/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{max-width:100%;min-width:0}.started_ofw[_ngcontent-%COMP%]{max-width:168px;min-width:0}.checkbox-col[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center}@media screen and (max-width:600px){.started_ofw[_ngcontent-%COMP%]{max-width:80%;min-width:0}.checkbox-col[_ngcontent-%COMP%]{margin-bottom:1rem}}"];
export { styles as styles };
